import { onError } from '@apollo/client/link/error';
import { datadogLogs } from '@datadog/browser-logs';
import * as Sentry from '@sentry/browser';
import { GraphQLFormattedError } from 'graphql';

function isGraphQLError(value: unknown): value is GraphQLFormattedError {
  return value !== null && typeof value === 'object' && 'message' in value;
}

export const errorLink = onError(({ forward, graphQLErrors, networkError, operation }) => {
  // We're being defensive here because we've seen situtations where `graphQLErrors` is not
  // actually an array of `GraphQLFormattedError`.
  if (Array.isArray(graphQLErrors)) {
    graphQLErrors.forEach(error => {
      if (isGraphQLError(error)) {
        datadogLogs.logger.error('WebGraphQLLatencyMetric', {
          name: '[GraphQL Error]',
          message: error.message,
          locations: error.locations,
          path: error.path,
        });
      }
    });
  }

  if (networkError) {
    Sentry.captureException(networkError);
  }

  forward(operation);
});
